import "./AllocationFilter.scss";

import { useEffect, useRef, useState } from "react";

export type AllocationFilterValue = "ALL" | "MEDICARE" | "NON_MEDICARE";

type AllocationFilterOption = {
  value: AllocationFilterValue;
  label: string;
};

const FILTER_OPTIONS: AllocationFilterOption[] = [
  { value: "ALL", label: "All" },
  { value: "MEDICARE", label: "Medicare" },
  { value: "NON_MEDICARE", label: "Non-Medicare" },
];

type AllocationFilterProps = {
  value: AllocationFilterValue;
  onChange: (value: AllocationFilterValue) => void;
};

export const AllocationFilter = ({
  value,
  onChange,
}: AllocationFilterProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const selectedOption = FILTER_OPTIONS.find((opt) => opt.value === value);

  const handleOptionClick = (newValue: AllocationFilterValue) => {
    onChange(newValue);
    setIsOpen(false);
  };

  return (
    <div className="allocation-filter-wrapper">
      <div className="allocation-filter" ref={dropdownRef}>
        <button
          className="allocation-filter__button"
          onClick={() => setIsOpen(!isOpen)}
          type="button"
        >
          <span className="allocation-filter__icon">
            <i className="material-icons">filter_list</i>
          </span>
          <span className="allocation-filter__label">Filter</span>
          <span className="allocation-filter__value">
            {selectedOption?.label || "All"}
          </span>
          <span className={`allocation-filter__arrow ${isOpen ? "open" : ""}`}>
            <i className="material-icons">expand_more</i>
          </span>
        </button>

        {isOpen && (
          <div className="allocation-filter__dropdown">
            <input
              type="text"
              className="allocation-filter__search"
              placeholder="Filter..."
              readOnly
            />
            <div className="allocation-filter__options">
              {FILTER_OPTIONS.map((option) => (
                <button
                  key={option.value}
                  className={`allocation-filter__option ${
                    value === option.value ? "selected" : ""
                  }`}
                  onClick={() => handleOptionClick(option.value)}
                  type="button"
                >
                  {value === option.value && (
                    <span className="allocation-filter__check">
                      <i className="material-icons">check</i>
                    </span>
                  )}
                  <span>{option.label}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
